import './style.scoped.css';
import { Helmet } from 'react-helmet-async';
//import CookiesForm from '../../components/CookiesForm/CookiesForm';
import InfiniteScroll from "../../components/InfiniteScroll/InfiniteScroll";
import logo from '../../images/logo.png';
interface ContentProps {
};

const SPONSORSMEDIA = [
  "/images_photo/hackathon/sponsorzy_media/MEDIA/tvp3.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/Logo_TVP_info_rgb.jpg",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/radioOpole.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/nto.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/tvp3.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/Logo_TVP_info_rgb.jpg",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/radioOpole.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/nto.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/tvp3.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/Logo_TVP_info_rgb.jpg",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/radioOpole.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/nto.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/tvp3.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/Logo_TVP_info_rgb.jpg",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/radioOpole.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/nto.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/tvp3.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/Logo_TVP_info_rgb.jpg",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/radioOpole.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/nto.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/tvp3.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/Logo_TVP_info_rgb.jpg",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/radioOpole.png",
  "/images_photo/hackathon/sponsorzy_media/MEDIA/nto.png"
];

const SPONSORS = [
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/WI.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/ABK.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/kyndryl.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/logo_axabee-_rgb.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/nypd.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/LOGO-OPOLA-KOLOR_cmyk.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/Patronat_honorowy-01.jpg",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/wicewojewoda.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/WI.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/ABK.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/kyndryl.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/logo_axabee-_rgb.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/nypd.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/LOGO-OPOLA-KOLOR_cmyk.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/Patronat_honorowy-01.jpg",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/wicewojewoda.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/WI.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/ABK.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/kyndryl.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/logo_axabee-_rgb.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/nypd.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/LOGO-OPOLA-KOLOR_cmyk.png",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/Patronat_honorowy-01.jpg",
  "/images_photo/hackathon/sponsorzy_media/SPONSORZY/wicewojewoda.png"
];
const Hackathon: React.FC<ContentProps> = ({}) => {
    return (
      <main className='content'>
        <Helmet>
          <title>Hackathon 2025</title>
        </Helmet>


        <div className="h-hero">
            <h1>III Studencki Hackathon Politechniki Opolskiej</h1>
            <h4>im. świętej pamięci dr inż. Artura Smolczyka </h4>
            <h3>11 października 2025</h3>
            <h3>Dziękujemy wszystkim za udział i zapraszamy za rok :)</h3>
        </div>

        <div className="grid">
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>          
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>

          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
          <div className="backg-b"></div>
          <div className="backg-w"></div>
        </div>

        <div className='white-background'>
            <div className='what-is-it'>
                <h2>Hackathon się skończył</h2>
                <p>Dziękujemy wszystkim uczestnikom za udział w tegorocznym Hackathonie.</p>
                <p>Gratulacje zwycięzcom!</p>
                <div className='winers'>
                  <div className='winer-item'>
                    <p className='task-col'>Zadanie 1."Dokąd tupta nocą Tuptuś?" [AI/ML]</p>
                    <p>Trójca Informatyczna : Marek Garbacz, Kamil Szpak, Łukasz Maslo</p>
                  </div>
                  <div className='winer-item'>
                    <p className='task-col'>Zadanie 2."Doctor UX: Multiwersum Dostępności"  [UX/UI]</p>
                    <p>Pes Python : Yurii Holovko</p>
                  </div>
                  <div className='winer-item'>
                    <p className='task-col'>Zadanie 3."Kwadratowy Kartograf" [Przetwarzanie danych]</p>
                    <p>0x456C656B7472796B : Adam Kulig, Aleksander Piosek, Maja Sobolewska</p>
                  </div>
                  <div className='winer-item'>
                    <p className='task-col'>Zadanie 4."Kto to panu tak…poukładał" [Algorytmy]</p>
                    <p>BitByte : Kacper Boś</p>
                  </div>
                </div>
                <p>Do zobaczenia za rok!</p>
            </div>

            <h3 className="patrons">patroni medialni</h3>
            <InfiniteScroll icons={SPONSORSMEDIA}/>
            <h3 className="patrons">sponsorzy wydarzenia</h3>
            <InfiniteScroll icons={SPONSORS} isReversed={true} />

            <div className='past-hackathon'>
              <h2>Jak to było na Hackathonie 2025</h2>
              <div className='past-hackathon-img-block'>
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_1.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_4.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_5.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_2.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_3.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_6.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_7.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_8.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_9.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_10.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_16.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_17.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_18.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_11.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_12.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_13.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_14.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/h-2025_15.jpg" alt="" />
              </div>
            </div>


            {/*
            <div className='why'>
                <h2>Dlaczego warto wziąć udział?</h2>
                <div className='why-items'>
                  <div className='why-item col-lg-5 col-sm-10'>
                    <h3>Praktyczne doświadczenie</h3>
                    <p>Uczestnicy mają szansę na zdobycie praktycznych umiejętności w pracy nad projektami, które mogą być wykorzystane w przyszłej karierze</p>
                  </div>
                  <div className='why-item col-lg-5 col-sm-10'>
                    <h3>Współpraca</h3>
                    <p>Praca w zespołach pozwala na rozwijanie umiejętności interpersonalnych oraz zdolności do pracy w grupie</p>
                  </div>
                  <div className='why-item col-lg-5 col-sm-10'>
                    <h3>Różnorodne zadania</h3>
                    <p>Do rozwiązania uczestnicy otrzymają 4-5 zadań każde z innej dziedziny informatyki</p>
                  </div>
                  <div className='why-item col-lg-5 col-sm-10'>
                    <h3>Nagrody i wyróżnienia</h3>
                    <p>Na każde najlepsze rozwiązanie danego zadania przewidziana jest nagroda Finansowa</p>
                  </div>
                </div>
            </div>
            <div className='register' id='reg'>
              <h2>Rejestracja</h2>
              <h3>Rejestracja odbywa się na naszym serwerze Discord</h3>
              <div className="discord-btn">
                <a href=" " >Rejestracja jest zakończona</a>
              </div>
              <div className="download-items">
                <a href="/Regulamin_Hackathon_2025.pdf" download className='download-a'>Regulamin Hackathon 2025</a>
                <a href="Załącznik_nr_1.pdf" download className='download-a'>Załącznik dla osob niepełnoletnich</a>
                <a href="Załącznik_nr_2.pdf" download className='download-a'>Protokół odbioru nagród</a>
              </div>
              <p className='add-info'>*Jeśli jesteś niepełnoletni wydrukuj i podpisz powyższy załącznik. Przynieś w dniu wydarzenia</p>
            </div>
            <div className='where'>
              <div className='where-text-block col-lg-5 col-sm-10'>
                <h2>Kiedy i gdzie ?</h2>
                <div className='where-text'>
                  <p>11 października 2025 godz. 9:00-20:00</p>
                  <p>Zespół Szkół Zawodowych im. Stanisława Staszica</p>
                  <p>Opole, ul. Andrzeja Struga 16A</p>
                </div>
              </div>
              <div className='where-map-block col-lg-5 col-sm-10'>
                <iframe title="Mapa lokalizacji hackathonu Opole Struga 16A"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2529.291740778312!2d17.9251377!3d50.6588436!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47105310e3cbd631%3A0x4410c36062e44e08!2sAndrzeja%20Struga%2016A%2C%2045-073%20Opole!5e0!3m2!1spl!2spl!4v1756493699302!5m2!1spl!2spl" 
                    width="100%"
                    height="300"
                    style={{ border: 0, height: "300px" }}
                    allowFullScreen 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"></iframe>            
              </div>
            </div>
            <div className='past_hackathon'>
              <h2>Poprzedni Hackathon</h2>
              <div className='past-hackathon-img-block'>
                <img className="past-hackathon-img" src="/images_photo/hackathon/1.png" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/2.jpeg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/3.png" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/4.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/5.jpg" alt="" />
                <img className="past-hackathon-img" src="/images_photo/hackathon/6.jpg" alt="" />
              </div>
            </div>*/}
            <div className='organizators'>
              <h2>Organizatorzy</h2>
              <div className='organizators-items'>
                <img className="organizators-img" src="/images_photo/hackathon/stasziclogo-zgodlem.png" alt="" />
                <img className="organizators-img" src={logo} alt="" />
                <img className="organizators-img" src="/images_photo/hackathon/Logo-Politechnika-Opolska-Kolorowe.svg" alt="" />
              </div>
            </div>

        </div>


      </main>
    );
}
export default Hackathon;